/*
* 主入口
* zxw
* 创建时间：2026-01-25
*/

import './css/app.css';
import CNF from './incs/Config';
import {
    locale,
    AddRequestHeaders,
    DeleteCookies,
    rootReactDom,
} from './incs/FunHelper';


import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import cookie from 'react-cookies';
import $ from 'jquery';
import { createBrowserHistory } from 'history';
import {
    Layout,
    message,
    ConfigProvider,
    theme,
    Button,
    Space,
} from 'antd';
import { generate } from '@ant-design/colors';
import { PlusOutlined } from '@ant-design/icons';

// 导入导航组件
import ServiceReleaseMessage from './components/ServiceReleaseMessage';
import YHeader from './components/YHeader.js';
import YMenu from './components/YMenu.js';
import YMenuLogo from './components/YMenuLogo.js';

// 导入内容组件
import AppMarket from './pages/appMarket/AppMarket';             // 应用市场
import AppManagement from './pages/appManagement/AppManagement'; // 应用管理
import AppRun from './pages/appRun/AppRun.js';                   // 应用运行

// 创建应用组件
import AppCreateEntity from './pages/appTemplate/AppCreateEntity';  // 创建应用  

// 工作流
import AppWorkFlow from './pages/appWorkFlow/AppWorkFlow.js';

// 主题色全局变量
global.THEMECOLOR = cookie.load(CNF.cookies.keyThemeColor) ? cookie.load(CNF.cookies.keyThemeColor) : CNF.themeColors[0];

const { Sider, Content } = Layout;
const history = createBrowserHistory();
const { defaultAlgorithm, compactAlgorithm, darkAlgorithm } = theme;

const AppMain = (props) => {
    const {
        token: {
            colorBgBase,
            colorBgContent,
            colorBgSolid,
        },
    } = theme.useToken();

    /**
     * 根据uri获取对应的菜单名称
     * @param {string} uri - 要查找的路径
     * @param {Array} menuItems - 菜单数组，默认为全局变量menuItems
     * @returns {string|null} 返回菜单名称，未找到返回空
     */
    const getMenuName = (uri, menuItems = CNF.menuItems) => {
        // 如果菜单数组不存在，返回null
        if (!menuItems || !Array.isArray(menuItems)) {
            return null;
        }

        // 遍历菜单项
        for (const item of menuItems) {
            // 检查当前菜单项的uri是否匹配
            if (item.uri === uri) {
                return item.name;
            }

            // 如果有子菜单，递归查找子菜单
            if (item.submenu && Array.isArray(item.submenu)) {
                const subResult = getMenuName(uri, item.submenu);
                if (subResult) {
                    return subResult;
                }
            }
        }

        // 未找到匹配的uri
        return '';
    }

    /**
     * 根据uri更新内容组件，以此来路由
     * @param {*} uri 
     * @returns 
     */
    const setContent = (uri) => {
        var com = '';
        // 根据路径渲染内容组件
        /** 模块导航 **/
        if (uri === CNF.menuItems[0].submenu[0].uri) {
            com = <AppMarket
                isDarkMode={props.isDarkMode}
                uri={uri}
                setUri={props.setUri}
                menuName={getMenuName(uri)}
                appRunUri='/app/appRun/appTemplate/'
            />
        }
        else if (uri === CNF.menuItems[0].submenu[1].uri) {
            com = <AppManagement
                isDarkMode={props.isDarkMode}
                uri={uri}
                setUri={props.setUri}
                menuName={getMenuName(uri)}
                renderAppCreateEnity={renderAppCreateEnity}
                appRunUri='/app/appRun/appTemplate/'
            />
        }
        /** 模块导航 **/
        /** 实体导航 **/
        else if (uri.startsWith('/app/appRun/appTemplate/')) {
            // 实体导航
            // 应用运行，上一级为应用市场
            com = <AppRun
                isDarkMode={props.isDarkMode}
                uri={uri}
                setUri={props.setUri}
                pUri={CNF.menuItems[0].submenu[0].uri}
                menuName={'应用模板'}
                appId={uri.replace('/app/appRun/appTemplate/', '')}
            />
        }
        /** 实体导航 **/
        else {
            // 未选中任何菜单，默认跳转到第一个菜单
            props.setUri(CNF.menuItems[0].submenu[0].uri);
            uri = CNF.menuItems[0].submenu[0].uri;
        }

        return com;
    }

    /**
     * 渲染创建应用
     * @returns 
     */
    const renderAppCreateEnity = (setRefresh = null) => {
        rootReactDom && rootReactDom.render(
            <AppCreateEntity open={true} setRefresh={setRefresh} />
        );
    }

    return (
        <>
            <Layout hasSider>
                <Sider
                    trigger={null}
                    collapsible
                    collapsed={false}
                    style={{
                        background: colorBgBase,
                        padding: `0 ${CNF.basePadding}px`,
                    }}
                >
                    <YMenuLogo collapsed={false} />
                    {/* 创建应用 */}
                    <div style={{ marginTop: 10 }}>
                        <Button
                            style={{ width: '100%' }}
                            size='large'
                            color='primary'
                            variant='filled'
                            onClick={() => {
                                renderAppCreateEnity();
                            }}
                        >
                            <Space><PlusOutlined />创建应用</Space>
                        </Button>
                    </div>
                    {/* 创建应用 */}
                    <YMenu
                        uri={props.uri}
                        setUri={props.setUri}
                        btnLists={props.btnLists}
                    />

                </Sider>
                <Layout style={{
                    background: colorBgBase,
                    padding: '0 8px 8px 0',
                }}>
                    <YHeader
                        navLists={props.navLists}
                        isCompact={props.isCompact}
                        setIsCompact={props.setIsCompact}
                        setThemeColor={props.setThemeColor}
                        isDarkMode={props.isDarkMode}
                        setIsDarkMode={props.setIsDarkMode}
                    />
                    <Content
                        style={{
                            background: colorBgContent,
                            border: '1px solid',
                            borderColor: colorBgSolid,
                            borderRadius: 8,
                        }}
                    >
                        {
                            setContent(props.uri)
                        }
                    </Content>
                </Layout>
            </Layout >
        </>
    )
};

const XRouter = (props) => {
    const [uri, setUri] = useState(props.uri); // 当前路径

    /**
     * 根据uri渲染路由组件
     * @param {*} uri 
     * @returns 
     */
    const renderRouterDom = (uri) => {
        let dom = '';
        if (uri.startsWith('/app/appManagement/appWorkFlow/')) {
            // 工作流
            // 获取应用appId
            const appId = uri.split('/').at(-1);
            dom = <AppWorkFlow
                uri={uri}
                setUri={setUri}
                appId={appId}
                isDarkMode={props.isDarkMode}
            />
        }
        else {
            // 主应用
            dom = <AppMain
                preGroup={props.preGroup}
                navLists={props.navLists}
                btnLists={props.btnLists}
                serInfos={props.serInfos}
                themeColor={props.themeColor}
                setThemeColor={props.setThemeColor}
                isCompact={props.isCompact}
                setIsCompact={props.setIsCompact}
                isDarkMode={props.isDarkMode}
                setIsDarkMode={props.setIsDarkMode}
                uri={uri}
                setUri={setUri}
            />
        }

        history.push(uri);
        return dom;
    }

    return renderRouterDom(uri)
};

const App = () => {
    const [messageApi, contextHolder] = message.useMessage();

    // 切换主体色
    const [themeColor, setThemeColor] = useState(cookie.load(CNF.cookies.keyThemeColor) ? cookie.load(CNF.cookies.keyThemeColor) : CNF.themeColors[0]);
    // 是否紧凑的
    const [isCompact, setIsCompact] = useState(false);
    // 是否夜间的
    const [isDarkMode, setIsDarkMode] = useState(false);

    const [preGroup, setPreGroup] = useState('');
    const [navLists, setNavLists] = useState([]);
    const [btnLists, setBtnLists] = useState([]);
    const [serInfos, setSerInfos] = useState([]);

    // 风格颜色梯度值
    const colorStyleMapTokens = generate(CNF.colorStyle);

    // 初始化Uri
    const location = useLocation();

    useEffect(() => {
        $.ajax({
            url: `${CNF.api}policys`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done(function (data) {
            if (data.res === 0) {
                // 获取服务代码
                let serCodes = [];
                for (let i = 0; i < data.dat.nav_lists.length; i++) {
                    let serCode = data.dat.nav_lists[i].ptn.split('_')[1];
                    if (!serCodes.some(obj => obj === serCode)) {
                        serCodes.push(serCode);
                    }
                }
                setPreGroup(data.dat.pre_group);
                setNavLists(data.dat.nav_lists);
                setBtnLists(data.dat.btn_lists);
                setSerInfos(data.dat.ser_infos);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    // 若获取策略失败，直接退出登录
                    DeleteCookies();
                }, CNF.messageDuration * 1000);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
            setTimeout(function () {
                // 若获取策略失败，直接退出登录
                DeleteCookies();
            }, CNF.messageDuration * 1000);
        });
    }, [messageApi]);

    return (
        <ConfigProvider
            locale={locale}
            theme={{
                algorithm: isCompact ? compactAlgorithm : isDarkMode ? darkAlgorithm : defaultAlgorithm,
                token: {
                    /** 是否是暗色模式 */
                    isDarkMode: isDarkMode,

                    /** 主题色
                     * 用户可以切换主题色，主要改变的是按钮、按钮文章、输入框等
                     */
                    colorPrimary: themeColor,


                    /** 修改全局默认色 */
                    colorBorder: '#d9d9d9',
                    colorBgContainer: isDarkMode ? '#141414' : '#fff',
                    colorBgElevated: isDarkMode ? '#141414' : '#fff',


                    /** 基础 
                     * 就是没有特别要求的、默认的样式
                    */
                    colorBgBase: isDarkMode ? '#000' : CNF.colorBaseBg,                 // 基础背景颜色
                    colorBgContent: isDarkMode ? '#000' : '#fff',                       // 内容背景颜色  
                    colorBgSolid: isDarkMode ? '#fff' : CNF.colorBaseBorderSolid,       // 背景实线颜色
                    colorBgActive: isDarkMode ? '#1F1F1F' : colorStyleMapTokens[0],     // 激活背景颜色

                    colorBasePlaceholder: CNF.colorBasePlaceholder,                     // 基础提示颜色
                    colorSafety: CNF.colorSafety,                                       // 安全色
                    colorWarning: CNF.colorWarning,                                     // 警告色                       
                    colorDanger: CNF.colorDanger,                                       // 危险色           


                    /** 文本 */
                    colorTextMenu: isDarkMode ? '#fff' : '#fff',                        // 文本菜单颜色
                    colorTextBase: isDarkMode ? '#fff' : CNF.colorBaseText,             // 文本基本颜色


                    /** 步骤 */
                    colorStepBg: isDarkMode ? '#000' : CNF.colorStepBg,                 // 步骤背景颜色   
                    colorStepBgActive: isDarkMode ? '#1F1F1F' : CNF.colorBaseBgActive,  // 激活背景颜色


                    /** 画布 */
                    colorGraphBg: isDarkMode ? '#000' : CNF.colorGraphBg,


                    /** 风格 
                     * 网站默认风格，用户是不能更改的。
                    */
                    colorStyleBg: colorStyleMapTokens[0],          // 风格色浅色背景色         
                    colorStyleBgHover: colorStyleMapTokens[1],     // 风格色浅色背景悬浮态
                    colorStyleBorder: colorStyleMapTokens[2],      // 风格色描边色
                    colorStyleBorderHover: colorStyleMapTokens[3], // 风格色描边色悬浮态
                    colorStyleHover: colorStyleMapTokens[4],       // 风格色悬浮态
                    colorStyle: colorStyleMapTokens[5],            // 风格色
                    colorStyleActive: colorStyleMapTokens[6],      // 风格色激活态
                    colorStyleTextHover: colorStyleMapTokens[7],   // 风格色文本悬浮态
                    colorStyleText: colorStyleMapTokens[8],        // 风格色文本
                    colorStyleTextActive: colorStyleMapTokens[9],  // 风格色文本激活态
                },
                components: {
                    Layout: {
                        // siderBg: CNF.baseBgColor,
                    },
                    Dropdown: {
                        paddingBlock: 0,
                    },
                    Segmented: {
                        // 背景和边框
                        trackBg: isDarkMode ? '#000' : '#f5f5f5',         // 整个组件的背景色[reference:1]
                        trackPadding: 4,            // 组件内边距[reference:2]

                        // 默认状态
                        itemColor: 'rgba(0, 0, 0, 0.65)',      // 默认文字颜色[reference:3]
                        itemBg: 'transparent',                  // 默认背景（通常透明）
                        itemHoverBg: 'rgba(0, 0, 0, 0.06)',    // 悬浮背景色[reference:4]
                        itemHoverColor: isDarkMode ? '#fff' : 'rgba(0, 0, 0, 0.88)', // 悬浮文字颜色[reference:5]
                        itemActiveBg: 'rgba(0, 0, 0, 0.15)',   // 激活态背景色[reference:6]

                        // 选中状态
                        itemSelectedBg: '#ffffff',              // 选中项的背景色[reference:7]
                        itemSelectedColor: 'rgba(0, 0, 0, 0.88)', // 选中项的文字颜色[reference:8]
                    },
                },
            }}
        >
            {contextHolder}
            <XRouter
                preGroup={preGroup}
                navLists={navLists}
                btnLists={btnLists}
                serInfos={serInfos}
                themeColor={themeColor}
                setThemeColor={setThemeColor}
                isCompact={isCompact}
                setIsCompact={setIsCompact}
                isDarkMode={isDarkMode}
                setIsDarkMode={setIsDarkMode}
                uri={location.pathname}
            />
        </ConfigProvider>
    )
};

export default App